import { useContext } from 'react';
import { FullscreenLayoutContext } from '../FullscreenLayoutContext.js';

const useFullscreenLayoutCloseable = () => {
  const context = useContext(FullscreenLayoutContext);
  return Boolean(context.isCloseable);
};

export { useFullscreenLayoutCloseable };
//# sourceMappingURL=useFullscreenLayoutCloseable.js.map
